module.exports = __webpack_public_path__ + "img/portfolio-01.5dee8713.f8697c68.jpg";